<div class="dialog-loading">
    <h5>Espere por favor!</h5>
    <mat-spinner></mat-spinner>
</div>